import { useGraphQLQuery } from '@betterment/graphql';
import { useParams } from 'react-router-dom';

import { ForecasterAccountTitleDocument, ForecasterPurposeTitleDocument } from '../graphql/forecasterTitle.generated';

const AccountTitle = ({ accountId }: { accountId: string }) => {
  const { data } = useGraphQLQuery(ForecasterAccountTitleDocument, { variables: { accountId }, throwOnError: false });

  return data?.account?.name;
};

const PurposeTitle = ({ purposeId }: { purposeId: string }) => {
  const { data } = useGraphQLQuery(ForecasterPurposeTitleDocument, { variables: { purposeId }, throwOnError: false });

  return data?.purpose?.name;
};

export const ForecasterPageTitle = () => {
  const { purposeId, accountId } = useParams<{ purposeId?: string; accountId?: string }>();

  if (accountId) return <AccountTitle accountId={accountId} />;
  if (purposeId) return <PurposeTitle purposeId={purposeId} />;
  return null;
};
